"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartFragmentText = exports.VariantFragmentText = void 0;
exports.VariantFragmentText = `
  fragment VariantFragment on ProductVariant {
    id
    title
    price {
      amount
    }
    compareAtPrice {
      amount
    }
    availableForSale
    sku
    image {
      url
    }
    quantityAvailable
    selectedOptions {
      name
      value
    }
    product {
      handle
      productType
      vendor
      id
      title
			pricePro: metafield(key: "price_pro", namespace: "omnia") {
				value
			}
    }
  }
`;
exports.CartFragmentText = `
fragment CartFragment on Cart {
	id
	appliedGiftCards {
		id
    amountUsed {
      amount
    }
	}
	attributes {
		key
		value
	}
	buyerIdentity {
		email
		customer {
			id
		}
	}
	checkoutUrl
	cost {
		subtotalAmount {
			amount
		}
		totalAmount {
			amount
		}
	}
	discountAllocations {
		discountedAmount {
			amount
		}
	}
	discountCodes {
		applicable
		code
	}
	id
	lines(first: 250) {
		nodes {
			id
      attributes {
				key
				value
			}
			cost {
				totalAmount {
					amount
				}
			}
      discountAllocations {
				discountedAmount {
					amount
				}
			}
			quantity
			merchandise {
				... on ProductVariant {
					...VariantFragment
				}
			}
		}
	}
}
${exports.VariantFragmentText}
`;
